import React, { useState } from "react";
import clsx from "clsx";

type Props = {
  loading: boolean;
  onSearch: (q: string) => void;
  onClear: () => void;
  className?: string;
};

function SearchBar(props: Props) {
  const [query, setQuery] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    props.onSearch(query);
  };

  const clearSearch = () => {
    setQuery("");
    props.onClear();
  };

  const handleQueryChange = (value: string) => {
    if (value === "") {
      clearSearch();
    } else setQuery(value);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={clsx(
        "flex items-center gap-2 flex-1",
        props.className
      )}
    >
      <input
        type="text"
        className="flex-1 px-3 py-1.5 text-xs bg-gray-900 text-gray-200 border border-gray-700 rounded focus:outline-none focus:border-squawk-blue placeholder:text-gray-500"
        value={query}
        onChange={(e) => handleQueryChange(e.target.value)}
        placeholder="Search..."
        required
        autoFocus
      />

      <button
        type="submit"
        disabled={props.loading}
        className="px-3 py-1.5 text-xs font-medium rounded border border-blue-600 bg-blue-900/20 text-blue-400 hover:border-blue-500 hover:text-blue-300 hover:bg-blue-900/30 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
      >
        {props.loading ? "Searching..." : "Search"}
      </button>

      <button
        type="button"
        onClick={clearSearch}
        className="px-3 py-1.5 text-xs font-medium rounded bg-gray-700/50 border border-gray-600 text-gray-300 hover:bg-gray-700 hover:text-gray-100 transition-colors whitespace-nowrap"
      >
        Clear
      </button>
    </form>
  );
}

export default SearchBar;
